import { UserRole } from '@shared/modules/auth/classes/UserRole';

export enum ModalType {
  Candidate = UserRole.Candidate,
  UserContact = UserRole.UserContact,
  PhoneContact = UserRole.PhoneContact,
}
